import styled from 'styled-components'
import theme from '../../../styles/theme'

const StVideoPost = styled.div`

  position: relative;
  /* &.firstitem{
    z-index: 2;
  } */
  .videoWrapper{
    background-color: black;
    padding-top: ${theme.headerHeight};
    padding-bottom: ${theme.headerHeight};
    height: calc(100vh);
    .videoPlayerWrapper{

    }
    &.hovered{
      .videoOverlay{
        opacity: 1;
      }
    }
  }
  .videoOverlay{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: white;
    padding-top: calc(${theme.headerHeight} * 2);
    padding-left: 2rem;
    padding-right: 2rem;
    pointer-events: none;
    transition: opacity 0.4s ease-out;
    z-index: 2;
    &::before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 40%;
      background: linear-gradient(black, transparent);
      z-index: -1;
    }
    h2{
      font-size: 2rem;
      max-width: none;
      text-align: left;
      font-weight: normal;
    }
    .credits{
      text-align: left;
    }
  }
  .postvideo{
    max-width: ${theme.maxWidth};
    margin-left: auto;
    margin-right: auto;
  }
  .postwrap{
    /* border: 1px solid #f0f; */
    display: grid;
    align-items: center;
    padding: ${theme.spacing};
    position: relative;
    grid-template-columns: repeat(2, 1fr);
    @media(max-width: 800px){
      grid-template-columns: repeat(1, 1fr);
    }
    grid-gap: 3rem;
    /* z-index: -4; */
    /* opacity: 0.8; */
  }
  .subwrap{
    /* border: 1px solid #0f0; */
    text-align: center;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-left: 1rem;
    padding-right: 1rem;
    position: relative;
    z-index: 10;
    padding-bottom: 1rem;
    h3{
      font-size: 2.5rem;
      font-family: Arial, sans-serif;
      color: white;
      font-weight: bold;
      a{
        color: inherit;
      }
    }
  }
  .link{
    width: 100%;
    display: block;
    color: black;
  }
  h2{
    font-weight: bold;
    /* text-transform: uppercase; */
    font-size: 4rem;
    text-align: right;
    line-height: ${theme.titleheight};
    max-width: ${theme.normalWidth};
  }
  .length-large{
    h2{
      font-size: 3.6rem;
    }
    .subwrap{
      h3{
        font-size: 2.8rem;
      }
    }
  }
  .length-medium{
    h2{
      font-size: 4.2rem;
    }
    .subwrap{
      h3{
        font-size: 3.2rem;
      }
    }
  }
  .length-small{
    h2{
      font-size: 5rem;
      @media(max-width: 800px){
        &.large-word{
          font-size: 4rem;
        }
      }
    }
    .subwrap{
      h3{
        font-size: 3.5rem;
      }
    }
  }
  .more{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 2rem;
    svg{
      width: 100px;
      min-height: 20px;
      padding-left: 10px;
    }
  }
  .imgwrap{
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    opacity: 0.4; */
    position: relative;
    .playicon {
      position: absolute;
      bottom: 5px;
      right: 5px;
      border: 2px solid #fff;
      font-size: 2rem;
      background-color: white;
      padding: 0.5rem 2rem 0.3rem;
      color: black;
      border-radius: 6px;
    }
  }
  .excerpt{
    max-width: ${theme.normalWidth};
    text-align: right;
  }
`

export { StVideoPost }